import { Stack, StackProps } from '@mui/material';

export const MuiStack = (props: StackProps) => {
    const { children, ...other } = props;

    return (
        <Stack
            direction={'row'}
            justifyContent={'center'}
            {...other}
        >
            {children}
        </Stack>
    );
}
